<div
  #listGroupRoot
  (focus)="handleFocus($event)"
  [class.flex-space]="useFlexSpace"
  [style.max-height]="maxHeight"
  [style.min-height]="minHeight"
  [attr.tabIndex]="listTabIndex"
  [class]="listClassName"
>
  <ng-content></ng-content>
</div>

